import { useState, useEffect } from 'react';

export const useScrollProgress = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      // Get the total scrollable height
      const totalScroll = document.documentElement.scrollHeight - window.innerHeight;
      
      // Get current scroll position
      const currentScroll = window.scrollY;
      
      // Calculate scroll progress as a percentage
      const progress = totalScroll > 0 ? (currentScroll / totalScroll) * 100 : 0;
      
      setScrollProgress(Math.min(progress, 100));
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Call once to set initial value
    handleScroll();

    // Cleanup
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return scrollProgress;
};